import * as React               from 'react';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide }  from 'swiper/react';
import { LocalStorageService }  from 'ts-storage-service';

import RenderButton from '../buttons/base/RenderButton';

import './scss/style.scss';

function SliderBody(props) {
  const {
          bannerColor,
          bannerTextColor,
          buttonColor,
          buttonTextColor,
          label,
          onClose,
          urlKey,
          urlLabel,
        } = props;

  return (
    <div
      className={'banner-slide'}
      style={{ backgroundColor: bannerColor }}
    >
      <div
        className={'title'}
        style={{ color: bannerTextColor }}
      >{label}</div>
      <div className={'btns'}>
        {urlKey && urlLabel && (
          <RenderButton
            label={urlLabel}
            target={'_blank'}
            onClick={onClose}
            type={'link'}
            uri={urlKey}
            style={{
              backgroundColor: buttonColor,
              borderColor:     buttonTextColor,
              color:           buttonTextColor,
            }}
          />
        )}
        <span
          className={'close ic-close'}
          onClick={onClose}
          style={{ color: bannerTextColor }}
        />
      </div>
    </div>
  );
}

function HeaderBanner(props) {
  const { banners } = props;

  const ls = new LocalStorageService('banner');

  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [open, setOpen]                 = React.useState(ls.hasData('open') ? ls.getData('open') : true);

  const textColor = React.useMemo(() => {
    return {
      '#fff': 'white',
      '#000': 'black',
    }[banners[currentSlide]?.bannerTextColor] || 'none';
  }, [banners, currentSlide]);

  const handleCloseBanner = React.useCallback(() => {
    ls.setData('open', false, 1e4);

    setOpen(false);
  }, []);

  React.useEffect(() => {
    document.body.classList.toggle('show-header-banner', open);

    return () => {
      document.body.classList.remove('show-header-banner');
    };
  });

  if (!open) {
    return null;
  }

  return (
    <div className={`header-banner text-${textColor}`}>
      {banners.length === 0 ? (
        <SliderBody
          bannerColor={banners[0].bannerColor}
          bannerTextColor={banners[0].bannerTextColor}
          buttonColor={banners[0].buttonColor}
          buttonTextColor={banners[0].buttonTextColor}
          label={banners[0].label}
          urlKey={banners[0].urlKey}
          urlLabel={banners[0].urlLabel}
          onClose={handleCloseBanner}
        />
      ) : (
        <Swiper
          autoHeight
          autoplay={{
            delay:             5e3,
            pauseOnMouseEnter: true,
          }}
          loop
          modules={[Autoplay, Navigation]}
          navigation
          onSlideChange={(swiper) => {
            setCurrentSlide(swiper.realIndex);
          }}
          speed={8e2}
        >
          {banners.map((banner, bannerIndex) => {
            return (
              <SwiperSlide key={bannerIndex}>
                <SliderBody
                  bannerColor={banner.bannerColor}
                  bannerTextColor={banner.bannerTextColor}
                  buttonColor={banner.buttonColor}
                  buttonTextColor={banner.buttonTextColor}
                  label={banner.label}
                  onClose={handleCloseBanner}
                  urlKey={banner.urlKey}
                  urlLabel={banner.urlLabel}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </div>
  );
}

export default HeaderBanner;